import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  slalomTitle: {
    fontSize: '5.5rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  slalomSubtitle: {
    fontSize: '1.5rem',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
}));

export const SlalomHeader = () => {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      <Typography variant="h1" className={classes.slalomTitle}>
        slalom
      </Typography>
      <Typography variant="subtitle1" className={classes.slalomSubtitle}>
        Internal Developer Portal
      </Typography>
    </Box>
  );
};
